export const defaultLocale = 'en'
export const defaultFallbackLocale = 'en'
 
export const locales = [
    {
        code: 'en',
        name: 'English',
        dir: 'ltr',
    }    
]